import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";
import KickedByPositionPref from "./position-pref/kicked-by-position-pref";
import { FragmentMessages } from "../../common/fragment-messages";
import KickedFromDefaultValue from "./default-value/kicked-from-default-value";
import KickKickedFromRestrictedPositions from "./restricted-positions/kick-kicked-from-restricted-positions";

export default class Kick extends Fragment {
    constructor(kickedBy, kickedFrom) {
        super();

        this.kickedBy = kickedBy;
        this.kickedFrom = kickedFrom;

        this.requiredData = [
            {
                name: "kickedBy",
                type: FragmentDataType.Player,
                displayName: "Kicked By",
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new KickedByPositionPref(play, this).resolve()
            },
            {
                name: "kickedFrom",
                type: FragmentDataType.FieldPosition,
                displayName: "Kicked From",
                title: "Kicked From",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                restrictedPositions: (props) => {
                    return new KickKickedFromRestrictedPositions(
                        props
                    ).resolve();
                },
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage,
                defaultValue: ({ play, summaryContext }) => {
                    return new KickedFromDefaultValue(
                        play,
                        this,
                        summaryContext
                    ).resolve();
                }
            }
        ];
    }
    summarize(summaryContext, stringifier) {
        return new FragmentSummary("", "");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.kickedBy = this.kickedBy;
        summaryContext.fieldPosition = this.kickedFrom;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    getPlayers() {
        return [this.kickedBy];
    }

    getFieldPosition() {
        return this.kickedFrom;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            kickedBy: playerReducer(this.kickedBy)
        };
    }
}
